import { useEffect, useState } from 'react';
import { Filter } from '../../../../../../../../../constants/types';
import { handleApplyFilters } from '../../../../../../utils';

interface UseModalFiltersHook {
  modalFilters: Filter[];
  setModalFilters: (filters: Filter[]) => void;
  handleCancelClick: () => void;
  handleApplyFiltersClick: () => void;
}

export const useModalFilters = (
  filters: Filter[],
  setFilters: (newFilters: Filter[]) => void,
  toggle: () => void
): UseModalFiltersHook => {
  const [modalFilters, setModalFilters] = useState([...filters]);

  useEffect(() => {
    setModalFilters(filters);
  }, [filters]);

  const handleCancelClick = () => {
    setModalFilters(filters);
    toggle();
  };

  const handleApplyFiltersClick = () => {
    const definedFilters = handleApplyFilters(modalFilters);
    setFilters(definedFilters);
    toggle();
  };

  return {
    modalFilters,
    setModalFilters,
    handleCancelClick,
    handleApplyFiltersClick,
  };
};
